import { Box, CircularProgress, Typography } from "@mui/material";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { useEffect } from "react";
import { usePowerGeneratorAreaGetDashboardInfoMutation } from "~/graphql/types";
import "./style.css";

export const Dashboard: React.FC = () => {
  const [getDashboardInfo, { data, loading, error }] =
    usePowerGeneratorAreaGetDashboardInfoMutation({ fetchPolicy: "no-cache" });

  useEffect(() => {
    getDashboardInfo();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          minHeight: "60vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error || !data?.powerGeneratorAreaGetDashboardInfo) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          minHeight: "60vh",
        }}
      >
        <Typography color="error">
          Não foi possível carregar o dashboard.
        </Typography>
      </Box>
    );
  }

  const { embedToken, embedUrl, reportId } =
    data.powerGeneratorAreaGetDashboardInfo;

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "90vh",
        height: "90vh",
        padding: "25px",
        boxSizing: "border-box",
      }}
    >
      <div style={{ height: "100%", width: "100%" }}>
        <PowerBIEmbed
          embedConfig={{
            type: "report",
            id: reportId,
            embedUrl: embedUrl,
            accessToken: embedToken,
            tokenType: models.TokenType.Embed,
            settings: {
              panes: {
                filters: { expanded: false, visible: false },
                pageNavigation: { visible: false },
              },
              background: models.BackgroundType.Transparent,
            },
          }}
          cssClassName="powerbi-report"
          eventHandlers={new Map()}
        />
      </div>
    </Box>
  );
};
